import { Component, inject, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard/dashboard.service';
import { ContractComponent } from '../../components/contract/contract.component';
import { PageHeaderComponent } from '../../components/page-header/page-header.component';
import { LoadingService } from '../../services/loading.service';
import { Contract } from '../../interfaces/contract';

@Component({
    selector: 'mobilize-schedules',
    imports: [
        ContractComponent,
        PageHeaderComponent
    ],
    templateUrl: './schedules.component.html',
    styleUrl: './schedules.component.scss'
})
export class SchedulesComponent implements OnInit {

    private _dashboard = inject(DashboardService);
    private _loading = inject(LoadingService);

    contracts!: Contract[];

    ngOnInit() {
        this._loading.setLoadingState(true);
        this._dashboard.getDashboardContracts().subscribe(rsp => {
            this.contracts = rsp.data;
            this.contracts.forEach(contract => {
                contract.contract_extended_state = 'opened';
            });
            this._loading.setLoadingState(false);
        });
    }
}
